var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C6.89543 3 6 3.89543 6 5V7.35418C6.73294 6.52375 7.80531 6 9 6H15C16.1947 6 17.2671 6.52375 18 7.35418V5C18 3.89543 17.1046 3 16 3H8ZM18 13H6C5.44772 13 5 13.4477 5 14V17C5 17.5523 5.44772 18 6 18H18C18.5523 18 19 17.5523 19 17V14C19 13.4477 18.5523 13 18 13ZM17 11V10C17 8.89543 16.1046 8 15 8H9C7.89543 8 7 8.89543 7 10V11H17ZM4 5V11.7639L3.9768 11.7849C3.87839 11.336 3.47843 11 3 11H2C1.44772 11 1 11.4477 1 12C1 12.5523 1.44772 13 2 13H3C3.06013 13 3.11902 12.9947 3.17623 12.9845C3.06216 13.3017 3 13.6436 3 14V17C3 17.8885 3.38625 18.6868 4 19.2361V22C4 22.5523 4.44772 23 5 23H6C6.55228 23 7 22.5523 7 22V20H17V22C17 22.5523 17.4477 23 18 23H19C19.5523 23 20 22.5523 20 22V19.2361C20.6137 18.6868 21 17.8885 21 17V14C21 13.6436 20.9378 13.3017 20.8238 12.9845C20.881 12.9947 20.9399 13 21 13H22C22.5523 13 23 12.5523 23 12C23 11.4477 22.5523 11 22 11H21C20.5216 11 20.1216 11.336 20.0232 11.7849C20.0155 11.7778 20.0078 11.7708 20 11.7639V5C20 2.79086 18.2091 1 16 1H8C5.79086 1 4 2.79086 4 5ZM6 15.5C6 14.6716 6.67157 14 7.5 14C8.32843 14 9 14.6716 9 15.5C9 16.3284 8.32843 17 7.5 17C6.67157 17 6 16.3284 6 15.5ZM16.5 14C15.6716 14 15 14.6716 15 15.5C15 16.3284 15.6716 17 16.5 17C17.3284 17 18 16.3284 18 15.5C18 14.6716 17.3284 14 16.5 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck);
export default __webpack_public_path__ + "static/media/delivery-truck.6a5235b52bfba97590cae56fc2a276d2.svg";
export { ForwardRef as ReactComponent };